import React, { Component } from 'react';
import TablaFiltros from './TablaFiltros';
import BuscarMovimientosInput from './BuscarMovimientosInput';
 
class BuscadorCargoAjuste extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        
        const { destildarTildarCheckFiltroAjusteCargo, dataModalFiltrosCargoAjuste, ajusteCargocheckConfirmarAll, 
                destildarTildarCheckAllFiltroAjusteCargo, idChecksAjusteCargoArray, movimientosFiltradosPorDescripcion, filtrarMovimientosPorDescripcion } = this.props;

        return (
            <div>
                <div>
                    <input id="checkTodos" type="checkbox" name="checkTodos"  onClick={() => destildarTildarCheckAllFiltroAjusteCargo(ajusteCargocheckConfirmarAll, dataModalFiltrosCargoAjuste)} checked={ajusteCargocheckConfirmarAll} />
                    <label className="label-secondary modal-filtros-lbl" htmlFor={"checkTodos"}>Todos</label>
                </div>
                <div className="modal-filtros-input-buscar">
                    <BuscarMovimientosInput filtrarMovimientosPorDescripcion={filtrarMovimientosPorDescripcion} dataModalFiltrosCargoAjuste={dataModalFiltrosCargoAjuste} movimientosFiltradosPorDescripcion={movimientosFiltradosPorDescripcion} />
                </div>
                <div>
                    <TablaFiltros movimientosFiltradosPorDescripcion={movimientosFiltradosPorDescripcion} destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo} dataModalFiltrosCargoAjuste={dataModalFiltrosCargoAjuste} idChecksAjusteCargoArray={idChecksAjusteCargoArray} />
                </div>
            </div>
        );
    }
}

export default BuscadorCargoAjuste;